/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import * as auth from '../redux/AuthRedux'
import * as component from '../../../components/redux/componentRedux'
import {login, sendEmailAuthenCode} from '../apis'
import {saveDataLocalStorage, setUserInfo} from '../helpers'
import {messageError} from '../../../utils'
import {Alerts} from '../../../components'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import jwt_decode from 'jwt-decode'
import {useHistory} from 'react-router-dom'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    // .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
  rememberToken: false,
}

export function Login() {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  // const captchaRef = useRef<any>(null)
  // const CAPTCHA_SITEKEY = process.env.REACT_APP_SITE_KEY || 'TEST'
  // const enviroment = process.env.NODE_ENV

  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      // if ((enviroment == 'production' &&  captchaRef.current.getValue()) || enviroment == 'development') {
      setLoading(true)
      setTimeout(() => {
        let data = {
          model: {
            userNameOrEmail: values.email,
            password: values.password,
            remember: values.rememberToken,
            applicationType: 2,
          },
        }
        login(data)
          .then((res: any) => {
            if (res && !res.isError) {
              if (res.data.authenType == 0) {
                let decode: any = jwt_decode(res.data.accessToken)
                let cookies = {
                  accessToken: res.data.accessToken,
                  refreshToken: res.data.refreshToken,
                }
                let token = {
                  userId: res.data.userId,
                  userName: decode?.email,
                  phone: res.data.phoneNumber,
                  fullName: decode?.name,
                  companyName: res.data.companyName,
                  companyId: res.data.companyId,
                  companyCode: decode?.company_code,
                  divisionName: res.data.divisionName,
                  divisionCode: decode?.division_code,
                  divisionId: decode?.DivisionId,
                  accessToken: res.data.accessToken,
                  refreshToken: res.data.refreshToken,
                  sessionId: res.data.sessionId,
                }
                saveDataLocalStorage(res)
                setUserInfo(JSON.stringify(cookies))
                dispatch(auth.actions.login(token))
                setLoading(false)
              }
              if (res.data.authenType != 0) {
                history.push({
                  pathname: '/auth/create-pin-code',
                  state: {
                    email: values.email,
                    sessionId: res.data.sessionId,
                    userId: res.data.userId,
                    authenType: res.data.authenType,
                  },
                })
              }
            }
          })
          .catch((err: any) => {
            let errorType = err.response.data.type
            if (errorType) {
              setLoading(false)
              switch (errorType) {
                case '1':
                case '3':
                  dispatch(
                    component.actions.writeAlert({
                      show: true,
                      message: messageError(err.response),
                      type: 'error',
                    })
                  )
                  break
                case '2':
                  history.push({
                    pathname: '/auth/registration',
                    state: {
                      email: values.email,
                      errorType: errorType,
                      message: messageError(err.response),
                    },
                  })
                  break
                case '4':
                  history.push({
                    pathname: '/auth/create-pin-code',
                    state: {email: values.email},
                  })
                  break
                case '5':
                  history.push({
                    pathname: '/auth/registration',
                    state: {
                      email: values.email,
                      errorType: errorType,
                      message: messageError(err.response),
                    },
                  })
                  break
                default:
                  break
              }
              return
            }
            values.email = ''
            values.password = ''
            formik.touched.email = false
            formik.touched.password = false
            const alert = {
              show: true,
              message: messageError(err.response),
              type: 'error',
            }
            setLoading(false)
            dispatch(component.actions.writeAlert(alert))
          })
      }, 1000)
      // } else {
      //   dispatch(component.actions.writeAlert({
      //     show: true,
      //     type: 'warning',
      //     message: 'Click tôi không phải người máy để đăng nhập!'
      //   }))
      // }
    },
  })

  const handleRemoveReadonly = () => {
    let test = document.getElementById('email')
    if (test != undefined) test.removeAttribute('readonly')
  }

  return (
    <>
      <Alerts />
      <form
        className='form w-100'
        onSubmit={formik.handleSubmit}
        noValidate
        id='kt_login_signin_form'
        autoComplete='off'
      >
        {/* <a href='#' className='mb-12'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-tmiv.png')} className='h-80px' />
        </a> */}
        {/* <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Đăng nhập vào hệ thống</h1>
        <div className='text-gray-400 fw-bold fs-4'>
          Đăng nhập lần đầu?{' '}
          <Link to='/auth/registration' className='link-primary fw-bolder'>
            Tạo tài khoản
          </Link>
        </div>
      </div> */}
        {/* {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <div className='mb-10 bg-light-info p-8 rounded'>
          <div className='text-info'>
            Dùng tài khoản <strong>admin@demo.com</strong> và mật khẩu <strong>demo</strong>
          </div>
        </div>
      )} */}
        <a href='#' className='mb-12' style={{marginLeft: '95px'}}>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/logo-tmiv.png')}
            className='h-80px mb-5'
          />
        </a>
        <div className='fv-row mb-8'>
          <label className='form-label fs-6 fw-bolder text-dark'>Tài khoản</label>
          <input
            placeholder='Email'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
            id='email'
            type='email'
            name='email'
            autoComplete='false'
            readOnly
            onFocus={handleRemoveReadonly}
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          )}
        </div>
        <div className='fv-row mb-8'>
          <div className='d-flex justify-content-between mt-n5'>
            <div className='d-flex flex-stack mb-2'>
              <label className='form-label fw-bolder text-dark fs-6 mb-0'>Mật khẩu</label>
            </div>
          </div>
          <input
            type='password'
            autoComplete='false'
            maxLength={25}
            {...formik.getFieldProps('password')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.password && formik.errors.password,
              },
              {
                'is-valid': formik.touched.password && !formik.errors.password,
              }
            )}
          />
          {formik.touched.password && formik.errors.password && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.password}</span>
              </div>
            </div>
          )}
          {/* {enviroment == 'production' && (
            <div style={{marginLeft: '10px', marginTop: '10px'}}>
              <ReCAPTCHA sitekey={CAPTCHA_SITEKEY} ref={captchaRef} />
            </div>
            
          )} */}
        </div>
        <div className='fv-row mb-8 d-flex justify-content-between'>
          {/* <div style={{display: 'flex', gap: '10px'}}>
            <input type='checkbox' {...formik.getFieldProps('rememberToken')} />{' '}
            <span>Ghi nhớ đăng nhập</span>
          </div> */}

          <Link
            to='/auth/forgot-password'
            className='link-primary fs-6 fw-bolder'
            style={{marginLeft: '5px'}}
          >
            Quên mật khẩu?
          </Link>
        </div>
        <div className='text-center'>
          <button
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-lg btn-primary w-100 mb-5'
            // disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label'>Đăng nhập</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Vui lòng đợi...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>
    </>
  )
}
